const unexpectedTranslationKeys = new Set<string>([
  "package_types_delete",
  "pallet_not_found",
  "pallet_pallets",
  "performance_graph_by_sales_code",
  "picking_list_vehicle_order_title",
  "picking_list_vehicle_pallet_title",
  "planned_sales_visits",
  "please_wait_document_loading_message",
  "price_copy_price_category",
  "price_copy_price_category_hint",
  "price_cumulative_discounts",
  "price_discount_per",
  "price_finder_error_get",
  "price_from_price_list",
  "price_from_stage",
  "price_list_delete",
  "price_list_delete_prompt",
  "price_list_delete_unable_title",
  "price_list_prices",
  "price_lists_copy_from_pricelist",
  "price_lists_delete_prices",
  "price_run_copy",
  "price_stage",
  "price_to_stage",
  "price_updater_calculation_currency_per_barrel",
  "price_updater_calculation_currency_per_dutiable_hl_percent",
  "price_updater_direction",
  "price_updater_direction_decrease",
  "price_updater_direction_hint",
  "price_updater_direction_increase",
  "price_updater_price_list",
  "price_updater_price_list_hint",
  "pricing_categories_delete",
  "process_create_process",
  "process_header_expected_finish_date",
  "process_header_expected_finish_date_at_start",
  "process_header_expected_output_at_start",
  "process_header_has_printed_labels",
  "process_header_process_type",
  "process_header_recipe_name",
  "process_header_remaining_expected_output",
  "process_ingredient_qty_to_use",
  "process_ingredient_source_process_remaining_expected_qty",
  "process_ingredient_units",
  "process_ingredient_use_ingredient_from_other_process",
  "process_output_cost_price",
  "process_output_no_matching_target_ingredient",
  "process_output_quantity_moved",
  "process_output_use_ingredient_title",
  "process_produced_item_to_batch_number",
  "process_use_all_ingredients",
  "process_vessels_current_vessel_usage",
  "process_vessels_log",
  "process_vessels_measured_volume_of_destination_after_movement",
  "product_active",
  "product_active_hint",
  "product_allergy_notes",
  "product_allergy_notes_hint",
  "product_allow_description_change",
  "product_allow_description_change_hint",
  "product_alternate_cost_price",
  "product_barcode",
  "product_barcode_hint",
  "product_beerflex_code_hint",
  "product_brand_active",
  "product_brand_active_hint",
  "product_brand_best_before_days",
  "product_brand_best_before_days_hint",
  "product_brand_best_before_days_keg",
  "product_brand_best_before_days_keg_hint",
  "product_brand_code",
  "product_brand_code_hint",
  "product_brand_container_notes",
  "product_brand_container_notes_hint",
  "product_brand_could_not_delete",
  "product_brand_could_not_save",
  "product_brand_create",
  "product_brand_delete",
  "product_brand_delete_confirmation",
  "product_brand_edit",
  "product_brand_label_type",
  "product_brand_label_type_hint",
  "product_brand_other_notes",
  "product_brand_other_notes_hint",
  "product_brand_title",
  "product_brand_use_best_before_days_keg",
  "product_brand_use_best_before_days_keg_hint",
  "product_cost_price_inc_duty",
  "product_cost_price_inc_duty_hint",
  "product_create_details",
  "product_create_details_hint",
  "product_create_groups_and_codes",
  "product_create_groups_and_codes_hint",
  "product_create_labelling",
  "product_create_labelling_hint",
  "product_create_pricing",
  "product_create_pricing_hint",
  "product_create_product",
  "product_delete_confirmation",
  "product_details",
  "product_dutiable_litres",
  "product_dutiable_litres_hint",
  "product_duty_costs",
  "product_duty_costs_hint",
  "product_export_weight",
  "product_export_weight_hint",
  "product_frequencies",
  "product_frequencies_introduction",
  "product_frequency",
  "product_frequency_create_new",
  "product_frequency_hint",
  "product_glcode",
  "product_glcode_hint",
  "product_gross_price",
  "product_group",
  "product_package_size",
  "product_package_size_hint",
  "product_print_soil_association_logo",
  "product_print_soil_association_logo_hint",
  "product_rack_to_order",
  "product_rack_to_order_hint",
  "product_repackage",
  "product_repackage_hint",
  "product_sap_group",
  "product_sap_group_hint",
  "product_shop_code",
  "product_shop_code_hint",
  "product_tasting_notes",
  "product_tasting_notes_hint",
  "product_use_brand_allergy_notes",
  "product_use_brand_allergy_notes_hint",
  "product_use_brand_tasting_notes",
  "product_use_brand_tasting_notes_hint",
  "product_vat_code",
  "product_vat_code_hint",
  "product_weight",
  "product_weight_hint",
  "production_assembly",
  "production_assembly_actual_output",
  "production_assembly_batch_number_required",
  "production_assembly_cannot_complete_no_quantity",
  "production_assembly_complete_title",
  "production_assembly_completed",
  "production_assembly_current_cost",
  "production_assembly_due",
  "production_assembly_expected_cost",
  "production_assembly_expected_output",
  "production_assembly_from_packaging",
  "production_assembly_product",
  "production_assembly_recipe_name",
  "production_assembly_recipe_output",
  "production_assembly_started",
  "production_assembly_stock_location",
  "production_assembly_variation",
  "production_batch_from_recipe",
  "production_change_ingredient_requirements",
  "production_choose_production_type",
  "production_choose_production_type_title",
  "production_complete_assembly",
  "production_complete_batch",
  "production_complete_v1",
  "production_create_new_kitting",
  "production_delete_confirmation",
  "production_in_progress_v1",
  "production_kitting_details",
  "production_kitting_list",
  "production_monitoring_last_reading",
  "production_monitoring_probes",
  "production_monitoring_tools_title",
  "production_new_assembly",
  "production_new_batch",
  "production_new_kitting",
  "production_new_recipe",
  "production_packaging_assembly_abv",
  "production_packaging_assembly_abv_hint",
  "production_packaging_assembly_batch_number",
  "production_packaging_assembly_batch_number_hint",
  "production_packaging_assembly_begin_assembly",
  "production_packaging_assembly_best_before",
  "production_packaging_assembly_best_before_hint",
  "production_packaging_assembly_complete_assembly",
  "production_packaging_assembly_cost_of_assembly",
  "production_packaging_assembly_cost_per_unit",
  "production_packaging_assembly_details",
  "production_packaging_assembly_due_date",
  "production_packaging_assembly_due_date_hint",
  "production_packaging_assembly_expected_quantity",
  "production_packaging_assembly_expected_quantity_hint",
  "production_packaging_assembly_line_items",
  "production_packaging_assembly_location",
  "production_packaging_assembly_location_hint",
  "production_packaging_assembly_name",
  "production_packaging_assembly_new_name",
  "production_packaging_assembly_notes",
  "production_packaging_assembly_notes_hint",
  "production_packaging_assembly_number_returnable_filled",
  "production_packaging_assembly_print_labels_confirmation",
  "production_packaging_assembly_print_labels_confirmation_title",
  "production_packaging_assembly_print_labels_needs_batch",
  "production_packaging_assembly_quality_control",
  "production_packaging_assembly_quantity_assembled",
  "production_packaging_assembly_quantity_assembled_hint",
  "production_packaging_assembly_quantity_required",
  "production_packaging_assembly_recipe_multiplier",
  "production_packaging_assembly_recipe_multiplier_hint",
  "production_packaging_assembly_return_to_assembly",
  "production_packaging_assembly_returnable_containers_filled",
  "production_packaging_assembly_returnable_containers_filled_hint",
  "production_packaging_assembly_select_recipe",
  "production_packaging_assembly_select_recipe_hint",
  "production_packaging_best_before_days",
  "production_packaging_best_before_days_hint",
  "production_packaging_list_v1",
  "production_packaging_process",
  "production_packaging_process_notes",
  "production_packaging_process_notes_hint",
  "production_picking_list_oldest_batch",
  "production_picking_list_oldest_batch_qty",
  "production_picking_list_recommend_by_assembly",
  "production_plan_assembly",
  "production_plan_batch",
  "production_planned_v1",
  "production_process_completed_by",
  "production_recipe_assembly_abv",
  "production_recipe_assembly_abv_hint",
  "production_recipe_assembly_batch_number",
  "production_recipe_assembly_batch_number_hint",
  "production_recipe_assembly_begin_assembly",
  "production_recipe_assembly_complete_assembly",
  "production_recipe_assembly_cost_of_assembly",
  "production_recipe_assembly_cost_per_unit",
  "production_recipe_assembly_details",
  "production_recipe_assembly_due_date",
  "production_recipe_assembly_due_date_hint",
  "production_recipe_assembly_expected_quantity",
  "production_recipe_assembly_expected_quantity_hint",
  "production_recipe_assembly_line_items",
  "production_recipe_assembly_location",
  "production_recipe_assembly_location_hint",
  "production_recipe_assembly_name",
  "production_recipe_assembly_new_name",
  "production_recipe_assembly_quality_control",
  "production_recipe_assembly_quantity_assembled",
  "production_recipe_assembly_quantity_assembled_hint",
  "production_recipe_assembly_quantity_required",
  "production_recipe_assembly_recipe_multiplier",
  "production_recipe_assembly_recipe_multiplier_hint",
  "production_recipe_assembly_select_recipe",
  "production_recipe_assembly_select_recipe_hint",
  "production_recipe_assembly_urn_is_auto_allocated",
  "production_recipe_assembly_urn_is_auto_allocated_hint",
  "production_recipe_list_v1",
  "production_recipe_process",
  "production_recipe_process_notes",
  "production_recipe_process_notes_hint",
  "production_record_result",
  "production_run_copy",
  "production_select_existing_kitting",
  "production_sequence",
  "production_setup_new",
  "production_vessel_assembly",
  "production_vessel_batch",
  "production_vessel_expected_finish_date",
  "production_vessel_litres_suffix",
  "production_vessel_recipe",
  "production_vessel_started",
  "production_view_kitting",
  "prompt_leave_message",
  "prompt_leave_message_title",
  "ptv_ro_guide",
  "purchase_order_cancel",
  "purchase_order_confirm_complete",
  "purchase_order_email_no",
  "purchase_order_email_yes",
  "purchase_order_uom",
  "purchase_order_view_all_stock",
  "purchase_orders_supplier_mismatch",
]);

export default unexpectedTranslationKeys;
